import styles from './style/ServiceChip.module.scss';
import { getServiceName } from '../../../constant/SERVICE_NAME_MAP';
import { getServiceColor } from '../../../constant/SERVICE_COLOR_MAP';

// 服務名稱 chip：傳入後端英文服務名（software_services.name），
// 顯示名走 SERVICE_NAME_MAP、配色走 SERVICE_COLOR_MAP，兩者以同一個 key 對照。
// 不要在呼叫端自己拼名稱或顏色，否則各頁又會漂掉。
const ServiceChip = ({ name, className = '' }) => {
  if (name == null || name === '') return null;

  const { bg, fg } = getServiceColor(name);

  return (
    <span className={`${styles.serviceChip} ${className}`} style={{ background: bg, color: fg }}>
      {getServiceName(name)}
    </span>
  );
};

export default ServiceChip;
